import Decimal from 'decimal.js';
import { NotificationMode } from '../enums/notifications';
import { MerchantType } from '../interfaces/delivery-company/merchants';

export const emptyMerchant: MerchantType = {
  id: '',
  name: '',
  phone_number: '',
  address: '',
  has_usable_password: false,
  notification_mode: NotificationMode.NONE,
  default_delivery_fee: [],
  shop_locations: [],
  default_return_fee: [],
  logo_url: null,
  is_active: true,
  show_package_description_in_invoice: false,
  critical_order_surcharge_method: null,
  critical_order_surcharge_factor: null
};
